// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RuleProperty = Record<string, any>
type Params = RuleProperty

export function getDefaultValue(property: RuleProperty) {
  if (Object.hasOwn(property, 'defaultValue')) return property.defaultValue
  switch (property.code) {
    case 'text':
    case 'select':
      return ''
    case 'multi-text':
    case 'multi-select':
    case 'multi-workflow-state-select':
    case 'multi-tag-select':
    case 'multi-object':
      return []
    case 'rule-schema':
      return {}
    case 'integer':
    case 'decimal':
    case 'slider':
      return 0
    case 'checkbox':
      return false
    default:
      return ''
  }
}

export function updateParams(params: Params, properties?: RuleProperty) {
  if (!properties) return params
  const updatedParams: Params = {}
  Object.entries(params).forEach(([key, value]) => {
    const format = properties[key].format
    if (value === undefined || (format === 'uuid' && value === '')) {
      // Skip empty UUIDs and undefined values
      return
    } else if (properties[key].code === 'multi-object') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      updatedParams[key] = value.map((item: any) => {
        return updateParams(item, properties[key].items.properties)
      })
    } else {
      updatedParams[key] = value
    }
  })
  return updatedParams
}
